import React from 'react';
import { useTranslation } from 'react-i18next';

const STATUS_STYLES = {
  connected: 'bg-green-100 text-green-700',
  not_connected: 'bg-yellow-100 text-yellow-700',
  expired: 'bg-red-100 text-red-700',
  inactive: 'bg-gray-100 text-gray-500',
};

const STATUS_KEYS = {
  connected: 'licences.status.connected',
  not_connected: 'licences.status.notConnected',
  expired: 'licences.status.expired',
  inactive: 'licences.status.inactive',
};

const LicenseStatusBadge = ({ status }) => {
  const { t } = useTranslation();

  if (!status || !STATUS_STYLES[status]) {
    return null;
  }

  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${STATUS_STYLES[status]}`}
    >
      {t(STATUS_KEYS[status])}
    </span>
  );
};

export default LicenseStatusBadge;
